import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { EnhancedProductCard } from '../shared/EnhancedProductCard';
import { PRODUCT_IMAGES } from '../../data/productImages';
import { useHorizontalScroll } from '../../lib/hooks/useHorizontalScroll';
interface ProductSectionProps {
  title: string;
  viewAllLink: string;
}
export const ProductSection = memo(function ProductSection({
  title,
  viewAllLink
}: ProductSectionProps) {
  const {
    scrollContainerRef,
    isMobile,
    handleScroll
  } = useHorizontalScroll();
  const products = [{
    id: 1,
    name: 'Gold Standard 100% Whey Protein',
    brand: 'Optimum Nutrition',
    price: 29.99,
    originalPrice: 39.99,
    discount: 25,
    rating: 4.8,
    reviewCount: 324,
    image: PRODUCT_IMAGES[0],
    isBestSeller: true
  }, {
    id: 2,
    name: 'ISO100 Hydrolyzed Protein Powder',
    brand: 'Dymatize',
    price: 24.99,
    originalPrice: 34.99,
    discount: 28,
    rating: 4.7,
    reviewCount: 256,
    image: PRODUCT_IMAGES[1]
  }, {
    id: 3,
    name: 'Original Pre Workout Powder',
    brand: 'C4',
    price: 19.99,
    originalPrice: 29.99,
    discount: 33,
    rating: 4.6,
    reviewCount: 189,
    image: PRODUCT_IMAGES[2]
  }, {
    id: 4,
    name: 'Nitro-Tech Whey Gold Protein Powder',
    brand: 'MuscleTech',
    price: 27.99,
    originalPrice: 39.99,
    discount: 30,
    rating: 4.5,
    reviewCount: 145,
    image: PRODUCT_IMAGES[3],
    isNew: true
  }, {
    id: 5,
    name: 'Syntha-6 Protein Powder',
    brand: 'BSN',
    price: 22.99,
    originalPrice: 31.99,
    discount: 28,
    rating: 4.4,
    reviewCount: 132,
    image: PRODUCT_IMAGES[4]
  }, {
    id: 6,
    name: 'Amino Energy',
    brand: 'Optimum Nutrition',
    price: 16.99,
    originalPrice: 24.99,
    discount: 32,
    rating: 4.3,
    reviewCount: 98,
    image: PRODUCT_IMAGES[0]
  }];
  return <div className="w-full" data-id="element-2587" data-mp="10b81se7u9r8q">
      <div className="container mx-auto px-4" data-id="element-2588" data-mp="10ag4myylflgc">
        <div className="flex items-center justify-between mb-6 bg-gradient-to-r from-[#1E2B55] to-[#162041] rounded-xl p-6 md:p-8" data-id="element-2589" data-mp="ve7vc272umh3">
          <div data-id="element-2590" data-mp="1a1sytx7v6npj">
            <span className="text-xs font-bold text-white bg-white bg-opacity-20 px-2 py-0.5 rounded-full mb-2 inline-block uppercase" data-id="element-2591" data-mp="1a4f39nzgkn3j">
              FEATURED
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-white" data-id="element-2592" data-mp="he6ugmqtbf1m">
              {title}
            </h2>
          </div>
          <a href={viewAllLink} className="text-white bg-white bg-opacity-20 hover:bg-opacity-30 px-4 py-2 rounded-full text-sm font-medium transition-colors" data-id="element-2593" data-mp="cgolwxgpj1u5">
            View All
          </a>
        </div>
        {isMobile ? <div className="relative -mx-4" data-id="element-2594" data-mp="21s74551tarpl">
            <div ref={scrollContainerRef} onScroll={handleScroll} className="flex overflow-x-auto snap-x snap-mandatory scrollbar-hide gap-3 px-4 pb-4" style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          WebkitOverflowScrolling: 'touch'
        }} data-id="element-2595" data-mp="1xrx0hz1hsddw">
              {products.map((product, idx) => <motion.div key={product.id} initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.05,
            duration: 0.4
          }} className="snap-start flex-shrink-0 w-[42vw] max-w-[200px]" data-id="element-2596" data-mp="20bjkylkt57eb" data-mpi={idx}>
                  <EnhancedProductCard product={product} data-id="element-2597" data-mp="3bs1iyq41zi32" />
                </motion.div>)}
            </div>
          </div> : <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4" data-id="element-2598" data-mp="1o4hrp0yzjuy3">
            {products.map((product, idx) => <motion.div key={product.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.05,
          duration: 0.4
        }} data-id="element-2599" data-mp="1e4qw0vyov9wf" data-mpi={idx}>
                <EnhancedProductCard product={product} data-id="element-2600" data-mp="1x1ic6wixp8w9" />
              </motion.div>)}
          </div>}
      </div>
    </div>;
});